"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Header;
const constants_1 = require("core/constants");
const React = __importStar(require("react"));
const view_utils_1 = require("utils/view-utils");
// import Team from "models/team";
// import User from "models/user";
// import Division from "models/division";
const header_menu_1 = __importDefault(require("./header-menu"));
require("./header.scss");
require("@teamsnap/snap-ui/build/snap-ui.min.css");
function Header(props) {
    const { membersLoaded, teamsLoaded, isCommissionerOfAnything, user, activeTeams, retiredTeams, teams, myLeagues } = props;
    return (React.createElement("header", { className: "Header", "data-ui": "account" },
        React.createElement("div", { className: "Header-container Grid u-flexAlignItemsCenter" },
            React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                React.createElement("div", { className: "Header-banner Grid u-flexAlignItemsCenter" },
                    React.createElement("div", { className: "Grid-cell u-sizeFit" },
                        React.createElement("span", { className: "Header-bannerLogo" },
                            React.createElement("img", { alt: "TeamSnap Logo", src: "https://storage.googleapis.com/ts_assets_prod-classic_assets/logo-default-82d2b864bc99c55657a7042d85cad358.png " }))),
                    React.createElement("div", { className: "Grid-cell u-sizeFill" },
                        React.createElement("h1", { className: "Header-bannerTitle" }, (0, view_utils_1.fullName)(user))))),
            React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                React.createElement("div", { className: "Header-welcoming u-textRight" }, user.isAdmin ? (React.createElement("a", { id: "admin-link", href: constants_1.TEAMSNAP_URL + '/admin' }, "Go to Admin")) : (React.createElement("small", null,
                    "Howdy, ",
                    user.firstName,
                    "! Welcome to TeamSnap"))),
                React.createElement(header_menu_1.default, { membersLoaded: membersLoaded, teamsLoaded: teamsLoaded, isCommissionerOfAnything: isCommissionerOfAnything, user: user, activeTeams: activeTeams, retiredTeams: retiredTeams, teams: teams, myLeagues: myLeagues })))));
}
